import { render, staticRenderFns } from "./glPreviewImage.vue?vue&type=template&id=840d0754&scoped=true"
import script from "./glPreviewImage.vue?vue&type=script&lang=js"
export * from "./glPreviewImage.vue?vue&type=script&lang=js"
import style0 from "./glPreviewImage.vue?vue&type=style&index=0&id=840d0754&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840d0754",
  null
  
)

export default component.exports